import React, { ReactNode, useContext, useEffect, useState } from 'react';

import TicketDashboardContext from '@totem/components/ticketing/ticketDashboard/TicketDashboardContext';
import { DashboardResponse } from '@totem/components/ticketing/ticketDashboard/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { TICKET_DASHBOARD_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  children?: ReactNode;
};

const TicketDashboardContainer = ({ children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<DashboardResponse | null>(null);

  useEffect(() => {
    setLoading(true);

    fetch(`${TICKET_DASHBOARD_ENDPOINT}/`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: DashboardResponse) => {
        setData(result);

        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [getApiToken]);

  return (
    <TicketDashboardContext.Provider value={{ loading, data }}>
      {children}
    </TicketDashboardContext.Provider>
  );
};

export default TicketDashboardContainer;
